// booking/hooks/useExchangeRate.js
import { useEffect, useRef } from "react";
import { currencyApi } from "../services/booking.api";
/**
 * 自动同步：
 * 1. supplier -> customer 汇率
 * 2. customer -> EUR 汇率
 */
export function useExchangeRate({
    supplierCurrency,
    customerCurrency,
    setFieldValue,
    isHydrating = false,
}) {
    const prevPairRef = useRef({ supplier: "", customer: "" });
    const reqIdRef = useRef(0);

    // 记录上次写入的值，避免重复 setFieldValue
    const prevRatesRef = useRef({
        supplierToCustomer: undefined,
        customerToEur: undefined,
    });

    useEffect(() => {
        if (isHydrating) return;

        const supplier = String(supplierCurrency || "").trim().toUpperCase();
        const customer = String(customerCurrency || "").trim().toUpperCase();

        const prevPair = prevPairRef.current;
        if (prevPair.supplier === supplier && prevPair.customer === customer) {
            return;
        }
        prevPairRef.current = { supplier, customer };

        const reqId = ++reqIdRef.current;
        let cancelled = false;

        const updateIfChanged = (path, nextVal, key) => {
            // Object.is 更稳：能处理 NaN 等特殊情况
            if (Object.is(prevRatesRef.current[key], nextVal)) return;

            prevRatesRef.current[key] = nextVal;
            setFieldValue(path, nextVal, false);
        };

        const run = async () => {
            try {
                // supplier -> customer
                const rateSupplierToCustomer =
                    !supplier || !customer || supplier === customer
                        ? 1
                        : await currencyApi.getExchangeRate(supplier, customer);

                if (cancelled || reqId !== reqIdRef.current) return;

                console.log("rateSupplierToCustomer:", rateSupplierToCustomer);

                updateIfChanged(
                    "pricingSnapshot.calculation.exchangeRate",
                    rateSupplierToCustomer,
                    "supplierToCustomer"
                );

                // customer -> EUR
                const rateCustomerToEur =
                    !customer || customer === "EUR"
                        ? 1
                        : await currencyApi.getExchangeRate(customer, "EUR");

                if (cancelled || reqId !== reqIdRef.current) return;

                updateIfChanged(
                    "pricingSnapshot.calculation.exchangeRateEur",
                    rateCustomerToEur,
                    "customerToEur"
                );
            } catch (err) {
                if (cancelled || reqId !== reqIdRef.current) return;

                updateIfChanged(
                    "pricingSnapshot.calculation.exchangeRate",
                    1,
                    "supplierToCustomer"
                );
                updateIfChanged(
                    "pricingSnapshot.calculation.exchangeRateEur",
                    1,
                    "customerToEur"
                );

                console.error("exchange rate fetch failed:", err);
            }
        };

        run();

        return () => {
            cancelled = true;
        };
    }, [supplierCurrency, customerCurrency, setFieldValue, isHydrating, currencyApi]);
}